// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rGQY","content":"styles_content__29xOL","row":"styles_row__2_xRF","footer":"styles_footer__23gIn","phraseLength":"styles_phraseLength__6Vk_n"};